




















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import StarRating from "vue-star-rating";
import http from "@/methods/http.ts";

@Component({
  components: {
    StarRating,
  },
  filters: {
    imageFilter(value) {
      return value.trim().substring(0, 1);
    },
  },
})
export default class Company extends Vue {
  @Prop(String) name;
  @Prop(Number) rating;
  @Prop(Array) cats;
  @Prop(String) desc;
  @Prop(Boolean) state;
  @Prop(String) address;
  @Prop(String) img;
  @Prop(String) slug;

  faces = [];
  count = "";

  specListInfo() {
    http(`companies/${this.slug}/specialists`, "get", false, {
      page_size: 3,
    }).then((r) => {
      this.faces = r.data.results;
      this.count = r.data.count;
    });
  }

  created() {
    this.specListInfo();
  }
}
